const ProfileServices = {
  computed: {
    ...Vuex.mapState(['profile', 'services', 'schedules', 'availability']),
  },
  template: `
      <div class="uk-margin-large-bottom">
        
        <ul v-if="profile.type === 'P'">
          <li>Destaca tu perfil sobre tus competidores</li>
          <li>Mantén a tus potenciales empleadores informados</li>
          <li>Promociona los servicios que ofreces por medio de una buena descripción y añadiendo imágenes</li>
        </ul>
        <ul v-else>
          <li>Destaca tu perfil sobre tus competidores</li>
          <li>Mantén a tus potenciales clientes informados</li>
          <li>Promociona los servicios que ofreces por medio de una buena descripción y añadiendo imágenes</li>
        </ul>
        
        <router-view></router-view>

        <p class="uk-margin-medium-bottom">
          <a href="/ayuda/como-publicar-tus-servicios/">
            Consulta la ayuda sobre los servicios.
          </a>
        </p>
        
      </div>
	`,
};
